<svg class="{{iconClassList}}" *ngIf = "isUseSmartIcon()">
    <use xmlns:xlink="http://www.w3.org/1999/xlink" [attr.xlink:href]="getHref()"></use>
</svg>

<img   class="{{iconClassList}}" *ngIf = "!isUseSmartIcon()" [src]="getIcon()">